import React from 'react';
import { useTranslation } from 'react-i18next';
import usePageTitle from '../../helpers/usePageTitle';

const ResetPassword = () => {
  const { t } = useTranslation();

  usePageTitle('reset_password');
  
  return (
    <div>
    </div>
  );
};

export default ResetPassword;
